import { GAME_WHEEL_BET } from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const setBets = bets => socket.request(GAME_WHEEL_BET, bets)
